import { Box, Icon, InlineStack, Text } from '@shopify/polaris'
import { AlertTriangleIcon } from '@shopify/polaris-icons'

export const UpgradeBanner = ({ children }: { children: any }) => (
  <InlineStack gap="200" blockAlign="start" wrap={false}>
    <Box>
      <Icon source={AlertTriangleIcon} tone="warning" />
    </Box>
    <Text as="span">{children}</Text>
  </InlineStack>
)
